import { useProvideCoreFetch } from '~/composables/useProvideCoreFetch'

import { useMiscCurrencyStore } from '~/stores/miscCurrency'

import { provideFetchPlanCheckout } from '~/api-core/Subscription/Plan'

export function useGrooverPlusSubscribeCta() {
  const { coreFetch } = useProvideCoreFetch()
  const { selectedPlanId } = storeToRefs(useSubscriptionStore())
  const { targetCurrency: TARGET_CURRENCY } = storeToRefs(
    useMiscCurrencyStore(),
  )
  const stripeCheckoutModalClientSecret = useState<string | undefined>(
    'stripeCheckoutModalClientSecret',
    () => undefined,
  )

  async function createStripeCheckoutSession() {
    const fetchPlanCheckout = provideFetchPlanCheckout(coreFetch)

    const { client_secret: clientSecret } = await fetchPlanCheckout({
      planId: selectedPlanId.value,
      returnUrl: location.href.replace(location.hash, ''),
      currency: TARGET_CURRENCY.value,
    })

    stripeCheckoutModalClientSecret.value = clientSecret
  }

  return {
    createStripeCheckoutSession,
  }
}
